/** Study-guide quiz banks for Calculus & Analytical Geometry — 20 MCQs per section. */

export const DIFF_RULES_QUIZ = [
  {
    prompt: "Derivative of $x^7$ is:",
    options: ["$x^6$", "$7x^6$", "$7x^7$"],
    answer: "B",
    explanation: "Power rule $nx^{n-1}$.",
  },
  {
    prompt: "If $f(x)=3x^2-5x+1$, then $f'(2)$ equals:",
    options: ["$7$", "$12$", "$3$"],
    answer: "A",
    explanation: "$f'=6x-5$; at $2$: $12-5=7$.",
  },
  {
    prompt: "$(uv)'$ equals:",
    options: ["$u'v'$", "$u'+v'$", "$u'v+uv'$"],
    answer: "C",
    explanation: "Product rule.",
  },
  {
    prompt: "$\\dfrac{d}{dx}\\sin(3x)$ equals:",
    options: ["$\\cos(3x)$", "$3\\cos(3x)$", "$-3\\sin(3x)$"],
    answer: "B",
    explanation: "Chain rule.",
  },
  {
    prompt: "$\\dfrac{d}{dx}\\ln(5x)$ for $x>0$ equals:",
    options: ["$\\dfrac{1}{5x}$", "$5/x$", "$\\dfrac{1}{x}$"],
    answer: "C",
    explanation: "$\\ln(5x)=\\ln 5+\\ln x$, so derivative is $1/x$.",
  },
  {
    prompt: "Quotient rule for $f=u/v$ is:",
    options: ["$(u'v-uv')/v^2$", "$(u'v+uv')/v^2$", "$(uv'-u'v)/v^2$"],
    answer: "A",
    explanation: "Standard quotient rule.",
  },
  {
    prompt: "$\\dfrac{d}{dx}e^{2x}$ equals:",
    options: ["$2e^{2x}$", "$e^{2x}$", "$2xe^{2x}$"],
    answer: "A",
    explanation: "Chain rule on exponential.",
  },
  {
    prompt: "If $y=\\cos x$, then $y'$ equals:",
    options: ["$-\\cos x$", "$-\\sin x$", "$\\sin x$"],
    answer: "B",
    explanation: "Standard trig derivative.",
  },
  {
    prompt: "$\\dfrac{d}{dx}(x^2\\sin x)$ equals:",
    options: ["$x^2\\cos x$", "$2x\\cos x$", "$2x\\sin x+x^2\\cos x$"],
    answer: "C",
    explanation: "Product rule.",
  },
  {
    prompt: "$\\dfrac{d}{dx}\\tan x$ equals:",
    options: ["$\\sec x$", "$\\sec^2 x$", "$-\\csc^2 x$"],
    answer: "B",
    explanation: "Standard.",
  },
  {
    prompt: "Chain rule: $\\dfrac{d}{dx}f(g(x))$ equals:",
    options: ["$f'(x)g'(x)$", "$f(g'(x))$", "$f'(g(x))g'(x)$"],
    answer: "C",
    explanation: "Outer times inner.",
  },
  {
    prompt: "If $f(x)=1/x$, then $f'(x)$ equals:",
    options: ["$-1/x^2$", "$1/x^2$", "$-1/x$"],
    answer: "A",
    explanation: "Power $-1$: $-x^{-2}$.",
  },
  {
    prompt: "$\\dfrac{d}{dx}\\sqrt{x}$ equals:",
    options: ["$\\sqrt{x}/2$", "$1/\\sqrt{x}$", "$\\dfrac{1}{2\\sqrt{x}}$"],
    answer: "C",
    explanation: "$x^{1/2}$ differentiates to $\\tfrac12 x^{-1/2}$.",
  },
  {
    prompt: "If $h(x)=\\dfrac{x^2+1}{x}$, then $h'(x)$ equals:",
    options: ["$1-1/x^2$", "$1+1/x^2$", "$2x$"],
    answer: "A",
    explanation: "Write $x+x^{-1}$: derivative $1-x^{-2}$.",
  },
  {
    prompt: "$\\dfrac{d}{dx}\\ln(\\cos x)$ on $(-\\pi/2,\\pi/2)$ equals:",
    options: ["$-\\sec x$", "$-\\tan x$", "$\\tan x$"],
    answer: "B",
    explanation: "$(1/\\cos x)\\cdot(-\\sin x)=-\\tan x$.",
  },
  {
    prompt: "$\\dfrac{d}{dx}\\sec(2x)$ equals:",
    options: ["$2\\sec(2x)\\tan(2x)$", "$\\sec(2x)\\tan(2x)$", "$2\\tan^2(2x)$"],
    answer: "A",
    explanation: "Chain rule with $\\frac{d}{du}\\sec u = \\sec u \\tan u$ and $u=2x$ gives $2\\sec(2x)\\tan(2x)$.",
  },
  {
    prompt: "If $y = x^{\\sqrt{x}}$ for $x > 0$, logarithmic differentiation yields $\\dfrac{dy}{dx}$ equal to:",
    options: ["$\\sqrt{x}\\,x^{\\sqrt{x}-1}$", "$x^{\\sqrt{x}}\\left(\\dfrac{\\ln x + 2}{2\\sqrt{x}}\\right)$", "$x^{\\sqrt{x}}\\left(\\dfrac{\\ln x}{\\sqrt{x}}\\right)$"],
    answer: "B",
    explanation: "Taking logs: $\\ln y = \\sqrt{x}\\ln x$. Differentiating gives $\\frac{y'}{y} = \\frac{\\ln x}{2\\sqrt{x}} + \\frac{\\sqrt{x}}{x} = \\frac{\\ln x + 2}{2\\sqrt{x}}$.",
  },
  {
    prompt: "$\\dfrac{d}{dx}\\arcsin(3x)$ for $|x| < 1/3$ equals:",
    options: ["$\\dfrac{1}{\\sqrt{1-9x^2}}$", "$\\dfrac{3}{1+9x^2}$", "$\\dfrac{3}{\\sqrt{1-9x^2}}$"],
    answer: "C",
    explanation: "Standard inverse sine derivative with chain rule factor of $3$ in the numerator.",
  },
  {
    prompt: "$\\dfrac{d}{dx} e^{\\cos(x^2)}$ equals:",
    options: ["$-2x\\sin(x^2)e^{\\cos(x^2)}$", "$-\\sin(x^2)e^{\\cos(x^2)}$", "$2x\\cos(x^2)e^{\\cos(x^2)}$"],
    answer: "A",
    explanation: "Chain rule through exponential, cosine, and inner quadratic: $e^{\\cos(x^2)} \\cdot (-\\sin(x^2)) \\cdot 2x$.",
  },
  {
    prompt: "$\\dfrac{d}{dx}\\ln|\\sec x + \\tan x|$ simplifies to:",
    options: ["$\\tan x$", "$\\sec x$", "$\\sec x \\tan x$"],
    answer: "B",
    explanation: "$\\frac{\\sec x \\tan x + \\sec^2 x}{\\sec x + \\tan x} = \\frac{\\sec x(\\tan x + \\sec x)}{\\sec x + \\tan x} = \\sec x$.",
  },
];

export const DIFF_APPS_QUIZ = [
  {
    prompt: "If $A=\\pi r^2$ and $dr/dt=2$, then at $r=3$, $dA/dt$ equals:",
    options: ["$12\\pi$", "$9\\pi$", "$6\\pi$"],
    answer: "A",
    explanation: "$dA/dt=2\\pi r\\,dr/dt=2\\pi\\cdot 3\\cdot 2=12\\pi$.",
  },
  {
    prompt: "Critical points of differentiable $f$ occur where:",
    options: ["Only $f''=0$", "Only endpoints", "$f'=0$ or $f'$ undefined"],
    answer: "C",
    explanation: "Definition of critical point.",
  },
  {
    prompt: "If $f'(c)=0$ and $f''(c)<0$, then at $c$:",
    options: ["Local minimum", "Local maximum", "Inflection"],
    answer: "B",
    explanation: "Second derivative test.",
  },
  {
    prompt: "$f$ is increasing on an interval when:",
    options: ["$f'<0$", "$f''>0$", "$f'>0$ throughout"],
    answer: "C",
    explanation: "First derivative sign.",
  },
  {
    prompt: "L'Hôpital applies to which indeterminate forms?",
    options: ["Only $0\\cdot\\infty$", "$0/0$ or $\\infty/\\infty$", "Any quotient"],
    answer: "B",
    explanation: "Classical hypotheses.",
  },
  {
    prompt: "Evaluate $\\lim_{x\\to 0}\\dfrac{\\sin x-x}{x^3}$ using L'Hôpital as needed.",
    options: ["$-1/6$", "$1/6$", "$0$"],
    answer: "A",
    explanation: "Three applications yield $-1/6$.",
  },
  {
    prompt: "Absolute extrema of continuous $f$ on $[a,b]$ occur at:",
    options: ["Only inflection points", "Only where $f''=0$", "Critical points or endpoints"],
    answer: "C",
    explanation: "Extreme Value Theorem candidates.",
  },
  {
    prompt: "For $f(x)=x^3-3x$, local min occurs at:",
    options: ["$x=0$", "$x=1$", "$x=-1$"],
    answer: "B",
    explanation: "$f'=3x^2-3=0$ at $\\pm 1$; $f''(1)>0$.",
  },
  {
    prompt: "A ladder $10$ ft slides: base moves away at $2$ ft/s. When base is $6$ ft, height drops at:",
    options: ["$1.5$ ft/s", "$3$ ft/s", "$2$ ft/s"],
    answer: "A",
    explanation: "$x^2+y^2=100$, $2x x'+2y y'=0$; $y=8$, so $y'=- (6/8)\\cdot 2=-1.5$.",
  },
  {
    prompt: "Concavity upward means:",
    options: ["$f''>0$", "$f'>0$", "$f''<0$"],
    answer: "A",
    explanation: "Definition via second derivative.",
  },
  {
    prompt: "Maximize product $xy$ given $x+y=10$. Max product is:",
    options: ["$50$", "$25$", "$100$"],
    answer: "B",
    explanation: "$y=10-x$, $P=x(10-x)$; max at $x=5$, $P=25$.",
  },
  {
    prompt: "Inflection candidate where:",
    options: ["$f=0$", "$f'=0$ only", "$f''$ changes sign"],
    answer: "C",
    explanation: "Concavity change.",
  },
  {
    prompt: "Related rates: differentiate the constraint:",
    options: ["Only at $t=0$", "With respect to $t$ before plugging numbers", "After substituting all numbers"],
    answer: "B",
    explanation: "Keep variables symbolic until after $d/dt$.",
  },
  {
    prompt: "If $f'(x)=x^2(x-2)$, then $f$ has a local:",
    options: ["Local min at $x=0$", "Local max at $x=0$", "Neither max nor min at $x=0$"],
    answer: "C",
    explanation: "Sign of $f'$ does not change through $0$ (even power).",
  },
  {
    prompt: "Evaluate $\\lim_{x\\to\\infty}\\dfrac{\\ln x}{x}$.",
    options: ["$0$", "$1$", "$\\infty$"],
    answer: "A",
    explanation: "L'Hôpital: $(1/x)/1\\to 0$.",
  },
  {
    prompt: "Water flows into an inverted conical tank of radius $4\\text{ m}$ and height $8\\text{ m}$ at $3\\text{ m}^3/\\text{min}$. When water depth is $h = 4\\text{ m}$, the rate of rise $dh/dt$ is:",
    options: ["$\\dfrac{3}{4\\pi}\\text{ m/min}$", "$\\dfrac{3}{\\pi}\\text{ m/min}$", "$\\dfrac{3}{16\\pi}\\text{ m/min}$"],
    answer: "A",
    explanation: "Radius $r = h/2$, so volume $V = \\frac{\\pi}{12}h^3$. Then $dV/dt = \\frac{\\pi}{4}h^2 \\, dh/dt$. Substituting $h=4$ and $dV/dt=3$ gives $3 = 4\\pi \\, dh/dt \\implies dh/dt = \\frac{3}{4\\pi}$.",
  },
  {
    prompt: "The inflection point of $f(x) = x^3 - 6x^2 + 9x + 2$ is located at:",
    options: ["$(1, 6)$", "$(2, 4)$", "$(3, 2)$"],
    answer: "B",
    explanation: "$f'(x)=3x^2-12x+9$ and $f''(x)=6x-12=0 \\implies x=2$. Evaluating $f(2)=8-24+18+2=4$.",
  },
  {
    prompt: "Evaluate $\\lim_{x\\to 0}\\dfrac{e^x - 1 - x}{x^2}$ using L'Hôpital's Rule:",
    options: ["$0$", "$1$", "$\\dfrac{1}{2}$"],
    answer: "C",
    explanation: "First derivative gives $(e^x - 1)/(2x)$, second derivative gives $e^x/2 \\to 1/2$.",
  },
  {
    prompt: "Find the maximum area of a rectangle with perimeter $60\\text{ cm}$:",
    options: ["$225\\text{ cm}^2$", "$200\\text{ cm}^2$", "$250\\text{ cm}^2$"],
    answer: "A",
    explanation: "For a fixed perimeter, area is maximized when the rectangle is a square with side $s = 60/4 = 15$, yielding $15^2 = 225$.",
  },
  {
    prompt: "On which interval is $f(x) = 2x^3 - 3x^2 - 12x + 5$ strictly decreasing?",
    options: ["$(-\\infty, -1)$", "$(-1, 2)$", "$(2, \\infty)$"],
    answer: "B",
    explanation: "$f'(x) = 6x^2 - 6x - 12 = 6(x-2)(x+1) < 0$ when $-1 < x < 2$.",
  },
];

export const DIFF_ADV_QUIZ = [
  {
    prompt: "Implicitly, for $x^2+y^2=25$, $dy/dx$ equals:",
    options: ["$x/y$", "$-x/y$", "$-y/x$"],
    answer: "B",
    explanation: "$2x+2y y'=0\\Rightarrow y'=-x/y$.",
  },
  {
    prompt: "MVT says there is $c\\in(a,b)$ with $f'(c)$ equal to:",
    options: ["$\\dfrac{f(b)-f(a)}{b-a}$", "$f''(c)$", "$0$"],
    answer: "A",
    explanation: "Secant slope.",
  },
  {
    prompt: "Rolle's theorem additionally needs:",
    options: ["$f'>0$", "$f$ linear", "$f(a)=f(b)$"],
    answer: "C",
    explanation: "Special case of MVT.",
  },
  {
    prompt: "Logarithmic differentiation is handy for:",
    options: ["Only polynomials", "Only trig integrals", "Products/quotients of powers"],
    answer: "C",
    explanation: "Take $\\ln|y|$ then differentiate.",
  },
  {
    prompt: "If $y=x^x$ ($x>0$), then $y'$ equals:",
    options: ["$x^x(\\ln x+1)$", "$x^x\\ln x$", "$x\\cdot x^{x-1}$"],
    answer: "A",
    explanation: "$\\ln y=x\\ln x$; $y'/y=\\ln x+1$.",
  },
  {
    prompt: "Linear approximation of $f$ near $a$ is:",
    options: ["$f'(a)+f''(a)(x-a)$", "$f(a)+f'(a)(x-a)$", "$f(a)f'(a)$"],
    answer: "B",
    explanation: "Tangent line.",
  },
  {
    prompt: "Second derivative of $\\sin x$ is:",
    options: ["$-\\cos x$", "$\\cos x$", "$-\\sin x$"],
    answer: "C",
    explanation: "First $\\cos$, second $-\\sin$.",
  },
  {
    prompt: "If $x=\\cos t$, $y=\\sin t$, then $dy/dx$ equals:",
    options: ["$-\\cot t$", "$\\tan t$", "$-\\tan t$"],
    answer: "A",
    explanation: "$(dy/dt)/(dx/dt)=\\cos t/(-\\sin t)=-\\cot t$.",
  },
  {
    prompt: "Differential $dy$ equals:",
    options: ["$f(x)\\,dx$", "$f'(x)\\,dx$", "$f''(x)\\,dx$"],
    answer: "B",
    explanation: "Definition of differential.",
  },
  {
    prompt: "Derivative of $\\arcsin x$ is:",
    options: ["$1/\\sqrt{1-x^2}$", "$1/(1+x^2)$", "$-1/\\sqrt{1-x^2}$"],
    answer: "A",
    explanation: "Inverse trig standard.",
  },
  {
    prompt: "For $e^y=x$, $dy/dx$ equals:",
    options: ["$e^y$", "$1/x$", "$x$"],
    answer: "B",
    explanation: "$y=\\ln x$ for $x>0$.",
  },
  {
    prompt: "Higher-order: if $f(x)=e^{2x}$, then $f''(x)$ equals:",
    options: ["$2e^{2x}$", "$e^{2x}$", "$4e^{2x}$"],
    answer: "C",
    explanation: "$f'=2e^{2x}$, $f''=4e^{2x}$.",
  },
  {
    prompt: "Approximate $\\sqrt{9.1}$ using $f(x)=\\sqrt{x}$ at $a=9$:",
    options: ["$3.1$", "$3+0.1/3$", "$3+0.1/6$"],
    answer: "C",
    explanation: "$f'=1/(2\\sqrt{x})$; $3+(0.1)/(6)$.",
  },
  {
    prompt: "Implicit $xy=1$ gives $y'$ equal to:",
    options: ["$-y/x$", "$y/x$", "$-x/y$"],
    answer: "A",
    explanation: "$y+xy'=0\\Rightarrow y'=-y/x$.",
  },
  {
    prompt: "If $f$ is continuous on $[a,b]$ and differentiable on $(a,b)$ with $f(a)=f(b)$, Rolle guarantees:",
    options: ["$f''=0$ somewhere", "Some $c$ with $f'(c)=0$", "$f$ constant everywhere"],
    answer: "B",
    explanation: "Rolle conclusion.",
  },
  {
    prompt: "Find the slope of the tangent line to the circle $x^2 + y^2 = 25$ at the point $(3, -4)$:",
    options: ["$-\\dfrac{3}{4}$", "$\\dfrac{4}{3}$", "$\\dfrac{3}{4}$"],
    answer: "C",
    explanation: "Implicit differentiation gives $2x + 2y\\,y' = 0 \\implies y' = -x/y$. At $(3, -4)$, $y' = -3/(-4) = 3/4$.",
  },
  {
    prompt: "For $x^2 - y^2 = 4$, $\\dfrac{d^2y}{dx^2}$ in terms of $y$ simplifies to:",
    options: ["$-\\dfrac{4}{y^3}$", "$\\dfrac{4}{y^3}$", "$\\dfrac{1}{y}$"],
    answer: "A",
    explanation: "$y' = x/y$, so $y'' = \\frac{y - x y'}{y^2} = \\frac{y - x(x/y)}{y^2} = \\frac{y^2 - x^2}{y^3} = \\frac{-4}{y^3}$.",
  },
  {
    prompt: "If $f(1)=2$, $f(3)=10$, and $f$ is differentiable on $(1,3)$, the Mean Value Theorem guarantees a point $c$ where $f'(c)$ equals:",
    options: ["$4$", "$5$", "$8$"],
    answer: "A",
    explanation: "$f'(c) = \\frac{f(3)-f(1)}{3-1} = \\frac{10-2}{2} = 4$.",
  },
  {
    prompt: "Using linear approximation for $f(x) = \\sqrt{x}$ centered at $a = 16$, the estimate for $\\sqrt{16.8}$ is:",
    options: ["$4.08$", "$4.10$", "$4.12$"],
    answer: "B",
    explanation: "$L(x) = f(16) + f'(16)(x-16) = 4 + \\frac{1}{8}(0.8) = 4 + 0.10 = 4.10$.",
  },
  {
    prompt: "If $f(x) = x^3 + 2x - 1$, then $(f^{-1})'(2)$ equals:",
    options: ["$1/5$", "$5$", "$1/14$"],
    answer: "A",
    explanation: "Note $f(1) = 1 + 2 - 1 = 2$, so $f^{-1}(2) = 1$. Since $f'(x) = 3x^2 + 2$, $(f^{-1})'(2) = 1/f'(1) = 1/(3+2) = 1/5$.",
  },
];

export const INT_FUND_QUIZ = [
  {
    prompt: "$\\int 3x^2\\,dx$ equals:",
    options: ["$x^3+C$", "$6x+C$", "$3x^3+C$"],
    answer: "A",
    explanation: "Antiderivative of $3x^2$.",
  },
  {
    prompt: "$\\int_0^2 3x^2\\,dx$ equals:",
    options: ["$24$", "$8$", "$4$"],
    answer: "B",
    explanation: "$[x^3]_0^2=8$.",
  },
  {
    prompt: "FTC: $\\dfrac{d}{dx}\\int_0^x f(t)\\,dt$ equals:",
    options: ["$F(0)$", "$f'(x)$", "$f(x)$"],
    answer: "C",
    explanation: "FTC I.",
  },
  {
    prompt: "$\\int\\cos x\\,dx$ equals:",
    options: ["$-\\sin x+C$", "$\\cos x+C$", "$\\sin x+C$"],
    answer: "C",
    explanation: "Standard.",
  },
  {
    prompt: "Average value of continuous $f$ on $[a,b]$ is:",
    options: ["$\\int_a^b f$", "$\\dfrac{1}{b-a}\\int_a^b f$", "$f((a+b)/2)$"],
    answer: "B",
    explanation: "Definition.",
  },
  {
    prompt: "$\\int 2x\\cos(x^2)\\,dx$ equals:",
    options: ["$\\sin(x^2)+C$", "$2\\sin(x^2)+C$", "$\\cos(x^2)+C$"],
    answer: "A",
    explanation: "$u=x^2$, $du=2x\\,dx$.",
  },
  {
    prompt: "Area between $y=x$ and $y=x^2$ on $[0,1]$ equals:",
    options: ["$1/6$", "$1/2$", "$1/3$"],
    answer: "A",
    explanation: "$\\int_0^1(x-x^2)\\,dx=[x^2/2-x^3/3]_0^1=1/6$.",
  },
  {
    prompt: "$\\int e^{3x}\\,dx$ equals:",
    options: ["$e^{3x}+C$", "$\\dfrac{1}{3}e^{3x}+C$", "$3e^{3x}+C$"],
    answer: "B",
    explanation: "Chain factor $1/3$.",
  },
  {
    prompt: "FTC II: $\\int_a^b f=F(b)-F(a)$ when $F'=f$ and:",
    options: ["$F$ is quadratic", "$f$ is any function", "$f$ is continuous on $[a,b]$"],
    answer: "C",
    explanation: "Hypotheses of FTC.",
  },
  {
    prompt: "$\\int_1^e\\dfrac{1}{x}\\,dx$ equals:",
    options: ["$e$", "$0$", "$1$"],
    answer: "C",
    explanation: "$[\\ln x]_1^e=1$.",
  },
  {
    prompt: "Indefinite integrals differ by:",
    options: ["Zero always", "A constant $C$", "A linear term"],
    answer: "B",
    explanation: "Family of antiderivatives.",
  },
  {
    prompt: "$\\int_0^{\\pi/2}\\sin x\\,dx$ equals:",
    options: ["$1$", "$2$", "$0$"],
    answer: "A",
    explanation: "$[-\\cos x]_0^{\\pi/2}=1$.",
  },
  {
    prompt: "Substitution $u=g(x)$ converts $\\int f(g(x))g'(x)\\,dx$ into:",
    options: ["$\\int u\\,du$ always", "$\\int f'(u)\\,du$", "$\\int f(u)\\,du$"],
    answer: "C",
    explanation: "Chain rule in reverse.",
  },
  {
    prompt: "If $F(x)=\\int_2^{x^2}\\sin t\\,dt$, then $F'(x)$ equals:",
    options: ["$2x\\sin(x^2)$", "$2x\\cos(x^2)$", "$\\sin(x^2)$"],
    answer: "A",
    explanation: "FTC + chain rule.",
  },
  {
    prompt: "$\\int(4x-1)\\,dx$ equals:",
    options: ["$4x^2-x+C$", "$2x^2-x+C$", "$2x^2+C$"],
    answer: "B",
    explanation: "Termwise antiderivatives.",
  },
  {
    prompt: "By FTC Part 1, $\\dfrac{d}{dx}\\int_1^{x^2} \\cos(t)\\,dt$ equals:",
    options: ["$\\cos(x^2)$", "$2x\\cos(x^2)$", "$-2x\\sin(x^2)$"],
    answer: "B",
    explanation: "Chain rule with variable upper limit: $\\cos(x^2) \\cdot \\frac{d}{dx}(x^2) = 2x\\cos(x^2)$.",
  },
  {
    prompt: "The average value of $f(x) = 3x^2 - 2x$ on the interval $[0, 2]$ is:",
    options: ["$2$", "$4$", "$3$"],
    answer: "A",
    explanation: "$\\frac{1}{2-0}\\int_0^2 (3x^2 - 2x)dx = \\frac{1}{2}[x^3 - x^2]_0^2 = \\frac{1}{2}(8 - 4) = 2$.",
  },
  {
    prompt: "Evaluate $\\int_{-2}^2 (x^5 + x^3\\cos x + 4)\\,dx$:",
    options: ["$0$", "$8$", "$16$"],
    answer: "C",
    explanation: "By symmetry, the odd integrand terms integrate to zero over $[-2, 2]$, leaving $\\int_{-2}^2 4\\,dx = 4(4) = 16$.",
  },
  {
    prompt: "The area between $y = x^2$ and $y = 2x$ is:",
    options: ["$\\dfrac{4}{3}$", "$\\dfrac{2}{3}$", "$2$"],
    answer: "A",
    explanation: "Curves intersect at $x=0$ and $x=2$. $\\int_0^2 (2x - x^2)dx = [x^2 - x^3/3]_0^2 = 4 - 8/3 = 4/3$.",
  },
  {
    prompt: "A particle moves with velocity $v(t) = 3t^2 - 12$. Its net displacement from $t = 0$ to $t = 3$ is:",
    options: ["$9$", "$-9$", "$-27$"],
    answer: "B",
    explanation: "Displacement is $\\int_0^3 (3t^2 - 12)dt = [t^3 - 12t]_0^3 = 27 - 36 = -9$.",
  },
];

export const INT_TECH_QUIZ = [
  {
    prompt: "Integration by parts uses:",
    options: ["$\\int u\\,dv=uv-\\int v\\,du$", "$\\int u\\,dv=u'v$", "$\\int uv=u'v'$"],
    answer: "A",
    explanation: "Undo product rule.",
  },
  {
    prompt: "$\\int\\ln x\\,dx$ equals:",
    options: ["$x\\ln x+C$", "$1/x+C$", "$x\\ln x-x+C$"],
    answer: "C",
    explanation: "Parts with $u=\\ln x$.",
  },
  {
    prompt: "$\\int_1^{\\infty}x^{-2}\\,dx$ converges to:",
    options: ["$2$", "$1$", "$\\infty$"],
    answer: "B",
    explanation: "$[-1/x]_1^{\\infty}=1$.",
  },
  {
    prompt: "Partial fractions for proper rational functions need:",
    options: ["Numerator constant only", "Numerator degree less than denominator", "Equal degrees"],
    answer: "B",
    explanation: "Otherwise divide first.",
  },
  {
    prompt: "$\\int\\dfrac{1}{x^2+1}\\,dx$ equals:",
    options: ["$\\arcsin x+C$", "$\\ln|x^2+1|+C$", "$\\arctan x+C$"],
    answer: "C",
    explanation: "Standard.",
  },
  {
    prompt: "Trig sub for $\\sqrt{a^2-x^2}$ often uses:",
    options: ["$x=a\\sin\\theta$", "$x=a\\tan\\theta$", "$x=a\\sec\\theta$"],
    answer: "A",
    explanation: "Classic substitution.",
  },
  {
    prompt: "$\\int\\sin^2 x\\,dx$ strategy starts with:",
    options: ["Partial fractions", "Parts only", "Power-reduction $\\sin^2=\\dfrac{1-\\cos 2x}{2}$"],
    answer: "C",
    explanation: "Even powers of sine/cosine.",
  },
  {
    prompt: "Disk method volume about $x$-axis for $y=f(x)$ from $a$ to $b$:",
    options: ["$\\pi\\int_a^b [f(x)]^2\\,dx$", "$2\\pi\\int_a^b f(x)\\,dx$", "$\\int_a^b f(x)\\,dx$"],
    answer: "A",
    explanation: "Disk formula.",
  },
  {
    prompt: "$\\int xe^{x}\\,dx$ equals:",
    options: ["$xe^{x}+C$", "$e^{x}(x-1)+C$", "$e^{x}+C$"],
    answer: "B",
    explanation: "Parts: $u=x$, $dv=e^x dx$.",
  },
  {
    prompt: "Arc length of $y=f(x)$ on $[a,b]$ is:",
    options: ["$\\int_a^b|f'|\\,dx$", "$\\int_a^b\\sqrt{1+(f')^2}\\,dx$", "$\\int_a^b f\\,dx$"],
    answer: "B",
    explanation: "Arc-length formula.",
  },
  {
    prompt: "$\\int_0^{\\infty}e^{-x}\\,dx$ equals:",
    options: ["$0$", "$\\infty$", "$1$"],
    answer: "C",
    explanation: "$[-e^{-x}]_0^{\\infty}=1$.",
  },
  {
    prompt: "Decompose $\\dfrac{1}{(x-1)(x+2)}$ as:",
    options: ["$\\dfrac{1/3}{x-1}-\\dfrac{1/3}{x+2}$", "$\\dfrac{1}{x-1}+\\dfrac{1}{x+2}$", "$\\dfrac{x}{x-1}$"],
    answer: "A",
    explanation: "$A(x+2)+B(x-1)=1$ yields $A=1/3$, $B=-1/3$.",
  },
  {
    prompt: "Trig integral $\\int\\sin^3 x\\,dx$ uses:",
    options: ["Partial fractions", "Only $u=x$", "Save one $\\sin$, convert rest to $\\cos$"],
    answer: "C",
    explanation: "Odd power of sine.",
  },
  {
    prompt: "Washer method includes:",
    options: ["$\\pi\\int(R^2-r^2)\\,dx$", "$\\pi\\int(R-r)\\,dx$", "$\\int R r\\,dx$"],
    answer: "A",
    explanation: "Outer^2 minus inner^2.",
  },
  {
    prompt: "$\\int\\sec x\\tan x\\,dx$ equals:",
    options: ["$-\\csc x+C$", "$\\sec x+C$", "$\\tan x+C$"],
    answer: "B",
    explanation: "Standard.",
  },
  {
    prompt: "Evaluating $\\int x^2 e^x\\,dx$ using tabular integration by parts yields:",
    options: ["$e^x(x^2 - 2x + 2) + C$", "$e^x(x^2 + 2x + 2) + C$", "$e^x(x^2 - 2x) + C$"],
    answer: "A",
    explanation: "Alternating signs give $x^2 e^x - 2x e^x + 2e^x + C = e^x(x^2 - 2x + 2) + C$.",
  },
  {
    prompt: "To evaluate $\\int \\dfrac{1}{x^2\\sqrt{x^2+9}}\\,dx$, the trigonometric substitution is:",
    options: ["$x = 3\\sin\\theta$", "$x = 3\\sec\\theta$", "$x = 3\\tan\\theta$"],
    answer: "C",
    explanation: "Sum of squares $x^2+a^2$ uses the tangent substitution $x = a\\tan\\theta$ with $a = 3$.",
  },
  {
    prompt: "The partial fraction decomposition of $\\dfrac{3x+5}{(x-1)(x+2)}$ has the form:",
    options: ["$\\dfrac{8/3}{x-1} + \\dfrac{1/3}{x+2}$", "$\\dfrac{1}{x-1} + \\dfrac{2}{x+2}$", "$\\dfrac{2}{x-1} + \\dfrac{1}{x+2}$"],
    answer: "A",
    explanation: "Multiply by denominator: $3x+5 = A(x+2) + B(x-1)$. Setting $x=1$ gives $8 = 3A \\implies A=8/3$. Setting $x=-2$ gives $-1 = -3B \\implies B=1/3$.",
  },
  {
    prompt: "The arc length of $y = \\dfrac{2}{3}x^{3/2}$ from $x = 0$ to $x = 3$ equals:",
    options: ["$\\dfrac{14}{3}$", "$\\dfrac{16}{3}$", "$7$"],
    answer: "A",
    explanation: "$y' = x^{1/2}$, so $1 + (y')^2 = 1 + x$. Length is $\\int_0^3 \\sqrt{1+x}\\,dx = [\\frac{2}{3}(1+x)^{3/2}]_0^3 = \\frac{2}{3}(8 - 1) = \\frac{14}{3}$.",
  },
  {
    prompt: "The improper integral $\\int_0^1 \\dfrac{1}{\\sqrt{x}}\\,dx$:",
    options: ["Diverges", "Converges to $1$", "Converges to $2$"],
    answer: "C",
    explanation: "$\\lim_{t\\to 0^+} [2\\sqrt{x}]_t^1 = \\lim_{t\\to 0^+} (2 - 2\\sqrt{t}) = 2$.",
  },
];

export const LIMITS_P1_QUIZ = [
  {
    prompt: "Evaluate $\\lim_{x\\to 3}\\dfrac{x^2-9}{x-3}$.",
    options: ["The limit does not exist", "$0$", "$6$"],
    answer: "C",
    explanation: "Factor $(x-3)(x+3)$ and cancel to get $x+3\\to 6$.",
  },
  {
    prompt: "Evaluate $\\lim_{x\\to 0}\\dfrac{\\sqrt{x+4}-2}{x}$.",
    options: ["$\\dfrac{1}{4}$", "$2$", "$0$"],
    answer: "A",
    explanation: "Rationalize the numerator; the conjugate yields $\\dfrac{1}{\\sqrt{x+4}+2}\\to\\dfrac{1}{4}$.",
  },
  {
    prompt: "For $f(x)=\\begin{cases}2x+1&x<1\\\\3&x\\ge 1\\end{cases}$, $\\lim_{x\\to 1^-}f(x)$ equals:",
    options: ["$1$", "$3$", "$2$"],
    answer: "B",
    explanation: "From the left, $2(1)+1=3$.",
  },
  {
    prompt: "If $|f(x)|\\le x^2$ near $0$, then $\\lim_{x\\to 0}f(x)$ equals:",
    options: ["$1$", "$0$", "The limit need not exist"],
    answer: "B",
    explanation: "Squeeze: $-x^2\\le f(x)\\le x^2$ and both sides go to $0$.",
  },
  {
    prompt: "Evaluate $\\lim_{x\\to 2}\\dfrac{x^2-5x+6}{x-2}$.",
    options: ["$-1$", "$0$", "$1$"],
    answer: "A",
    explanation: "Factor $(x-2)(x-3)$ and cancel: $x-3\\to-1$.",
  },
  {
    prompt: "$f$ is continuous at $a$ when:",
    options: ["$f$ is differentiable nearby", "$f'(a)$ exists", "$\\lim_{x\\to a}f(x)=f(a)$"],
    answer: "C",
    explanation: "Definition: limit exists and equals the function value.",
  },
  {
    prompt: "Evaluate $\\lim_{x\\to 4}\\dfrac{x-4}{\\sqrt{x}-2}$.",
    options: ["$2$", "$4$", "$1$"],
    answer: "B",
    explanation: "Rationalize: multiply by $\\sqrt{x}+2$ to get $\\sqrt{x}+2\\to 4$.",
  },
  {
    prompt: "The jump discontinuity of $g(x)=\\begin{cases}0&x<0\\\\1&x\\ge 0\\end{cases}$ at $0$ occurs because:",
    options: ["Left and right limits differ", "$g(0)$ is undefined", "Both one-sided limits equal $1$"],
    answer: "A",
    explanation: "Left limit is $0$, right limit is $1$.",
  },
  {
    prompt: "Evaluate $\\lim_{x\\to -2}\\dfrac{x^2-4}{x+2}$.",
    options: ["$0$", "$4$", "$-4$"],
    answer: "C",
    explanation: "Factor $(x-2)(x+2)$: cancel to $x-2\\to-4$.",
  },
  {
    prompt: "Evaluate $\\lim_{x\\to 0}\\dfrac{\\sin(5x)}{x}$.",
    options: ["$1$", "$5$", "$0$"],
    answer: "B",
    explanation: "Write $\\dfrac{\\sin(5x)}{5x}\\cdot 5\\to 1\\cdot 5=5$.",
  },
  {
    prompt: "For removable discontinuity at $c$, which must be true?",
    options: ["One-sided limits disagree", "Vertical asymptote at $c$", "Limit exists but $f(c)$ is wrong or missing"],
    answer: "C",
    explanation: "Removable means the two-sided limit exists.",
  },
  {
    prompt: "Evaluate $\\lim_{x\\to 1}\\dfrac{x^3-1}{x-1}$.",
    options: ["$3$", "$0$", "$1$"],
    answer: "A",
    explanation: "Factor $x^3-1=(x-1)(x^2+x+1)$: at $1$ get $3$.",
  },
  {
    prompt: "$\\lim_{x\\to 0^+}\\dfrac{1}{x}$ equals:",
    options: ["$0$", "$-\\infty$", "$+\\infty$"],
    answer: "C",
    explanation: "As $x\\to 0^+$, $1/x$ diverges to $+\\infty$.",
  },
  {
    prompt: "Evaluate $\\lim_{x\\to 9}\\dfrac{x-9}{\\sqrt{x}-3}$.",
    options: ["$3$", "$6$", "$0$"],
    answer: "B",
    explanation: "Rationalize: $\\sqrt{x}+3\\to 6$.",
  },
  {
    prompt: "If $\\lim_{x\\to a}f(x)=L$ and $\\lim_{x\\to a}g(x)=M$, then $\\lim(f+g)$ equals:",
    options: ["$L+M$", "$L/M$", "$LM$"],
    answer: "A",
    explanation: "Sum rule for limits.",
  },
  {
    prompt: "Evaluate $\\lim_{x\\to 0} \\dfrac{\\sqrt{4+x} - 2}{x}$:",
    options: ["$\\dfrac{1}{4}$", "$\\dfrac{1}{2}$", "$0$"],
    answer: "A",
    explanation: "Multiply numerator and denominator by conjugate $(\\sqrt{4+x}+2)$ to cancel $x$, leaving $1/(\\sqrt{4+x}+2) \\to 1/4$.",
  },
  {
    prompt: "The one-sided limit $\\lim_{x\\to 3^+} \\dfrac{2x}{x-3}$ equals:",
    options: ["$-\\infty$", "$\\infty$", "$6$"],
    answer: "B",
    explanation: "The numerator approaches $6 > 0$ while the denominator approaches $0$ through positive values, yielding $\\infty$.",
  },
  {
    prompt: "Evaluate $\\lim_{x\\to 2^-} \\dfrac{|x-2|}{x-2}$:",
    options: ["$1$", "$-1$", "$0$"],
    answer: "B",
    explanation: "For $x < 2$, $|x-2| = -(x-2)$, so the quotient is constantly $-1$.",
  },
  {
    prompt: "For $f(x) = \\begin{cases} x^2 + c & x \\le 2 \\\\ 3x - 1 & x > 2 \\end{cases}$, find $c$ so that $f$ is continuous everywhere:",
    options: ["$1$", "$2$", "$-1$"],
    answer: "A",
    explanation: "Match one-sided limits at $x=2$: $2^2 + c = 3(2) - 1 \\implies 4 + c = 5 \\implies c = 1$.",
  },
  {
    prompt: "If $2 - x^2 \\le g(x) \\le 2\\cos x$ for all $x$, the Squeeze Theorem implies $\\lim_{x\\to 0} g(x)$ equals:",
    options: ["$0$", "$1$", "$2$"],
    answer: "C",
    explanation: "Both bounding functions converge to $2$ as $x\\to 0$, forcing $\\lim_{x\\to 0}g(x) = 2$.",
  },
];

export const LIMITS_P2_QUIZ = [
  {
    prompt: "Evaluate $\\lim_{x\\to\\infty}\\dfrac{3x^2+1}{x^2-5}$.",
    options: ["$0$", "$3$", "$\\infty$"],
    answer: "B",
    explanation: "Divide by $x^2$: coefficients of leading terms give $3$.",
  },
  {
    prompt: "$\\lim_{x\\to\\infty}\\dfrac{\\sin x}{x}$ equals:",
    options: ["Does not exist", "$1$", "$0$"],
    answer: "C",
    explanation: "Squeeze: $|\\sin x/x|\\le 1/|x|\\to 0$.",
  },
  {
    prompt: "A horizontal asymptote $y=L$ means:",
    options: ["$\\lim_{x\\to\\infty}f(x)=L$ or $\\lim_{x\\to-\\infty}f(x)=L$", "$f'(x)=0$", "$f(L)=0$"],
    answer: "A",
    explanation: "Definition of horizontal asymptote.",
  },
  {
    prompt: "Evaluate $\\lim_{x\\to 0}\\dfrac{1-\\cos x}{x^2}$.",
    options: ["$\\dfrac{1}{2}$", "$0$", "$1$"],
    answer: "A",
    explanation: "Use $1-\\cos x=2\\sin^2(x/2)$ or L'Hôpital twice.",
  },
  {
    prompt: "IVT guarantees a root of continuous $f$ on $[a,b]$ when:",
    options: ["$f'(a)=0$", "$f$ is differentiable", "$f(a)$ and $f(b)$ have opposite signs"],
    answer: "C",
    explanation: "Opposite signs force a zero by IVT.",
  },
  {
    prompt: "Evaluate $\\lim_{x\\to\\infty}\\left(\\sqrt{x^2+x}-x\\right)$.",
    options: ["$\\infty$", "$\\dfrac{1}{2}$", "$0$"],
    answer: "B",
    explanation: "Rationalize: $\\dfrac{x}{\\sqrt{x^2+x}+x}\\to\\dfrac{1}{2}$.",
  },
  {
    prompt: "Vertical asymptote of $f(x)=\\dfrac{1}{x-2}$ occurs at:",
    options: ["$y=0$", "$x=2$", "$x=0$"],
    answer: "B",
    explanation: "Denominator zero while numerator nonzero.",
  },
  {
    prompt: "Evaluate $\\lim_{x\\to 0}\\dfrac{\\tan(3x)}{x}$.",
    options: ["$3$", "$0$", "$1$"],
    answer: "A",
    explanation: "$\\dfrac{\\sin(3x)}{\\cos(3x)\\,x}=3\\cdot\\dfrac{\\sin(3x)}{3x}\\cdot\\dfrac{1}{\\cos(3x)}\\to 3$.",
  },
  {
    prompt: "The form $\\infty/\\infty$ is:",
    options: ["Always $\\infty$", "Always $1$", "Indeterminate"],
    answer: "C",
    explanation: "Needs further analysis (algebra or L'Hôpital).",
  },
  {
    prompt: "For $f(x,y)=\\dfrac{xy}{x^2+y^2}$, as $(x,y)\\to(0,0)$ along $y=mx$ the limit is:",
    options: ["$0$", "$1$", "$\\dfrac{m}{1+m^2}$"],
    answer: "C",
    explanation: "Substitute $y=mx$: $\\dfrac{mx^2}{x^2(1+m^2)}=\\dfrac{m}{1+m^2}$.",
  },
  {
    prompt: "Because path limits for $xy/(x^2+y^2)$ depend on $m$, the 2D limit:",
    options: ["Equals $1/2$", "Does not exist", "Equals $0$"],
    answer: "B",
    explanation: "Different paths give different values.",
  },
  {
    prompt: "Evaluate $\\lim_{x\\to\\infty}\\dfrac{5x^3-2}{2x^3+x}$.",
    options: ["$\\dfrac{5}{2}$", "$0$", "$\\infty$"],
    answer: "A",
    explanation: "Leading coefficients: $5/2$.",
  },
  {
    prompt: "Slant asymptote appears for rational $f$ when:",
    options: ["Degrees are equal", "Degree(numerator)=degree(denominator)+1", "Denominator degree is larger"],
    answer: "B",
    explanation: "Polynomial division yields a linear quotient.",
  },
  {
    prompt: "Evaluate $\\lim_{x\\to(\\pi/2)^-}\\tan x$.",
    options: ["$+\\infty$", "$-\\infty$", "$0$"],
    answer: "A",
    explanation: "Approaching $\\pi/2$ from the left, $\\tan x\\to+\\infty$.",
  },
  {
    prompt: "If $f$ is continuous on $[0,1]$ with $f(0)=-1$ and $f(1)=2$, then $f(c)=0$ for some $c$ in:",
    options: ["Nowhere necessarily", "Only at an endpoint", "$(0,1)$"],
    answer: "C",
    explanation: "IVT applies.",
  },
  {
    prompt: "Find the slant asymptote of $f(x) = \\dfrac{2x^2 + 3x - 1}{x + 1}$:",
    options: ["$y = 2x + 1$", "$y = 2x - 1$", "$y = 2x$"],
    answer: "A",
    explanation: "Polynomial division gives $2x + 1 - \\frac{2}{x+1}$, so as $x\\to\\pm\\infty$ the curve approaches the line $y = 2x + 1$.",
  },
  {
    prompt: "Evaluate $\\lim_{x\\to\\infty} x\\sin\\left(\\dfrac{1}{x}\\right)$:",
    options: ["$0$", "$1$", "$\\infty$"],
    answer: "B",
    explanation: "Let $u = 1/x$; as $x\\to\\infty$, $u\\to 0^+$, so the limit becomes $\\lim_{u\\to 0}\\frac{\\sin u}{u} = 1$.",
  },
  {
    prompt: "Evaluate $\\lim_{x\\to 0} (1 + 3x)^{1/x}$:",
    options: ["$e^3$", "$3e$", "$1$"],
    answer: "A",
    explanation: "Standard exponential limit identity $\\lim_{t\\to 0}(1+kt)^{1/t} = e^k$ with $k=3$.",
  },
  {
    prompt: "The Intermediate Value Theorem guarantees that $f(x) = x^3 - 3x - 1$ has a real root on:",
    options: ["$[0, 1]$", "$[1, 2]$", "$[-1, 0]$"],
    answer: "B",
    explanation: "Evaluating endpoints: $f(1) = 1 - 3 - 1 = -3 < 0$ and $f(2) = 8 - 6 - 1 = 1 > 0$. By IVT, a root exists in $(1, 2)$.",
  },
  {
    prompt: "Evaluate $\\lim_{x\\to\\infty} \\left(\\sqrt{x^2 + 4x} - x\\right)$:",
    options: ["$0$", "$2$", "$4$"],
    answer: "B",
    explanation: "Multiply by conjugate: $\\frac{(x^2+4x) - x^2}{\\sqrt{x^2+4x}+x} = \\frac{4x}{x\\sqrt{1+4/x}+x} = \\frac{4}{\\sqrt{1+4/x}+1} \\to \\frac{4}{2} = 2$.",
  },
];

export const SERIES_P1_QUIZ = [
  {
    prompt: "If $a_n=\\dfrac{n}{n+1}$, then $\\lim a_n$ equals:",
    options: ["$1$", "$0$", "$\\infty$"],
    answer: "A",
    explanation: "Divide by $n$: $1/(1+1/n)\\to 1$.",
  },
  {
    prompt: "Geometric $\\sum_{n=0}^{\\infty}(1/3)^n$ sums to:",
    options: ["$1/3$", "$3$", "$\\dfrac{3}{2}$"],
    answer: "C",
    explanation: "$1/(1-1/3)=3/2$.",
  },
  {
    prompt: "If $a_n\\not\\to 0$, then $\\sum a_n$:",
    options: ["Converges", "Diverges", "Is geometric"],
    answer: "B",
    explanation: "nth-term test.",
  },
  {
    prompt: "Harmonic series $\\sum 1/n$:",
    options: ["Converges to $1$", "Diverges", "Converges to $e$"],
    answer: "B",
    explanation: "Classic divergence.",
  },
  {
    prompt: "p-series $\\sum 1/n^p$ converges when:",
    options: ["$p>0$", "$p\\ge 1$", "$p>1$"],
    answer: "C",
    explanation: "p-test.",
  },
  {
    prompt: "Telescoping $\\sum_{n=1}^{N}\\left(\\dfrac{1}{n}-\\dfrac{1}{n+1}\\right)$ equals:",
    options: ["$1-\\dfrac{1}{N+1}$", "$1/(N+1)$", "$N$"],
    answer: "A",
    explanation: "Most terms cancel.",
  },
  {
    prompt: "A sequence converges to $L$ means eventually terms are:",
    options: ["Equal to $L$ always", "Increasing", "Arbitrarily close to $L$"],
    answer: "C",
    explanation: "Epsilon definition.",
  },
  {
    prompt: "$\\sum_{n=0}^{\\infty}3\\left(\\dfrac{2}{5}\\right)^n$ equals:",
    options: ["$15/2$", "$5$", "$3$"],
    answer: "B",
    explanation: "$a/(1-r)=3/(1-2/5)=5$.",
  },
  {
    prompt: "Partial sum $s_N=\\sum_{n=1}^{N}a_n$. Series converges when:",
    options: ["$\\{s_N\\}$ converges", "$s_N$ is bounded above only", "$a_n\\to 0$ only"],
    answer: "A",
    explanation: "Definition.",
  },
  {
    prompt: "For $|r|\\ge 1$, geometric $\\sum r^n$:",
    options: ["Converges", "Sums to $1/(1-r)$", "Diverges (unless all zero)"],
    answer: "C",
    explanation: "Terms fail to go to $0$ when $|r|\\ge 1$.",
  },
  {
    prompt: "$a_n=(-1)^n$ has limit:",
    options: ["Does not exist", "$0$", "$1$"],
    answer: "A",
    explanation: "Oscillates between $-1$ and $1$.",
  },
  {
    prompt: "$\\sum 1/n^2$:",
    options: ["Equals $1$", "Converges", "Diverges"],
    answer: "B",
    explanation: "p-series with $p=2>1$.",
  },
  {
    prompt: "If $s_N=2-1/N$, then $\\sum a_n$ converges to:",
    options: ["$2$", "$0$", "$1$"],
    answer: "A",
    explanation: "$\\lim s_N=2$.",
  },
  {
    prompt: "Geometric first term $a=4$, ratio $r=-1/2$. Sum is:",
    options: ["$4$", "$\\dfrac{8}{3}$", "$-4$"],
    answer: "B",
    explanation: "$4/(1-(-1/2))=4/(3/2)=8/3$.",
  },
  {
    prompt: "Bounded monotonic sequences:",
    options: ["Oscillate", "Always diverge", "Converge"],
    answer: "C",
    explanation: "Monotone convergence theorem.",
  },
  {
    prompt: "The telescoping series $\\sum_{n=1}^\\infty \\dfrac{1}{n(n+1)}$ converges to:",
    options: ["$1/2$", "$1$", "$2$"],
    answer: "B",
    explanation: "Partial fractions: $\\frac{1}{n} - \\frac{1}{n+1}$. Partial sum $S_N = 1 - \\frac{1}{N+1} \\to 1$.",
  },
  {
    prompt: "The geometric series $\\sum_{n=0}^\\infty 3\\left(\\dfrac{2}{5}\\right)^n$ sums to:",
    options: ["$5$", "$3$", "$\\dfrac{15}{2}$"],
    answer: "A",
    explanation: "First term $a = 3$, ratio $r = 2/5$. Sum $S = \\frac{a}{1-r} = \\frac{3}{1 - 2/5} = \\frac{3}{3/5} = 5$.",
  },
  {
    prompt: "Which statement regarding the sequence $a_n = \\dfrac{3n^2 - 1}{2n^2 + 5n}$ is true?",
    options: ["Diverges to $\\infty$", "Converges to $3/2$", "Converges to $0$"],
    answer: "B",
    explanation: "Divide numerator and denominator by $n^2$: $\\frac{3 - 1/n^2}{2 + 5/n} \\to \\frac{3}{2}$.",
  },
  {
    prompt: "The $p$-series $\\sum_{n=1}^\\infty \\dfrac{1}{n^{2p-1}}$ converges if and only if:",
    options: ["$p > 1$", "$p > 1/2$", "$p \\ge 1$"],
    answer: "A",
    explanation: "A $p$-series requires exponent $> 1$. Here $2p - 1 > 1 \\implies 2p > 2 \\implies p > 1$.",
  },
  {
    prompt: "By the Monotone Convergence Theorem, a sequence $(a_n)$ is guaranteed to converge if it is:",
    options: ["Unbounded and increasing", "Bounded and monotonic", "Alternating in sign"],
    answer: "B",
    explanation: "Completeness of the real numbers guarantees that every bounded monotonic sequence has a finite limit.",
  },
];

export const SERIES_P2_QUIZ = [
  {
    prompt: "Ratio test: if $L=\\lim|a_{n+1}/a_n|<1$, then $\\sum a_n$:",
    options: ["Diverges", "Is inconclusive", "Converges absolutely"],
    answer: "C",
    explanation: "Ratio test.",
  },
  {
    prompt: "If the ratio limit is $L=1$, the test is:",
    options: ["Divergence", "Inconclusive", "Absolute convergence"],
    answer: "B",
    explanation: "Borderline case.",
  },
  {
    prompt: "Alternating series $\\sum(-1)^{n+1}b_n$ with $b_n\\downarrow 0$:",
    options: ["Converges", "Converges absolutely always", "Diverges"],
    answer: "A",
    explanation: "Leibniz test.",
  },
  {
    prompt: "Absolute convergence means:",
    options: ["Terms alternate", "$\\sum a_n$ diverges", "$\\sum|a_n|$ converges"],
    answer: "C",
    explanation: "Definition.",
  },
  {
    prompt: "Alternating harmonic series is:",
    options: ["Divergent", "Conditionally convergent", "Absolutely convergent"],
    answer: "B",
    explanation: "Converges by AST; absolute is harmonic.",
  },
  {
    prompt: "Root test uses:",
    options: ["$\\limsup\\sqrt[n]{|a_n|}$", "Integral of $a_n$", "$a_{n+1}/a_n$ only"],
    answer: "A",
    explanation: "Root test.",
  },
  {
    prompt: "For $\\sum\\dfrac{(-1)^n}{n}$, AST error after $N$ terms is at most:",
    options: ["$N$", "$1$", "$b_{N+1}=1/(N+1)$"],
    answer: "C",
    explanation: "Alternating remainder bound.",
  },
  {
    prompt: "Power series $\\sum c_n(x-a)^n$ has radius $R$ when ratio gives:",
    options: ["Convergence only at $a$", "Convergence for $|x-a|<R$", "Always all $x$"],
    answer: "B",
    explanation: "Definition of $R$.",
  },
  {
    prompt: "Interval of convergence of $\\sum x^n$ is:",
    options: ["$-1<x<1$", "$-1\\le x\\le 1$", "All real $x$"],
    answer: "A",
    explanation: "Geometric; endpoints diverge.",
  },
  {
    prompt: "Limit comparison with positive $b_n$: if $\\lim a_n/b_n=c\\in(0,\\infty)$, then:",
    options: ["Inconclusive", "Both converge or both diverge", "Only $a_n$ converges"],
    answer: "B",
    explanation: "Limit comparison.",
  },
  {
    prompt: "Ratio for $\\sum n!/n^n$: $L$ equals:",
    options: ["$\\infty$", "$1$", "$0$"],
    answer: "C",
    explanation: "$(n+1)!/(n+1)^{n+1}\\cdot n^n/n!\\to 0$; converges.",
  },
  {
    prompt: "Direct comparison: if $0\\le a_n\\le b_n$ and $\\sum b_n$ converges, then:",
    options: ["$\\sum a_n$ converges", "Inconclusive", "$\\sum a_n$ diverges"],
    answer: "A",
    explanation: "Comparison test.",
  },
  {
    prompt: "Radius of $\\sum\\dfrac{(x-2)^n}{n\\,3^n}$ is:",
    options: ["$3$", "$2$", "$1$"],
    answer: "A",
    explanation: "Ratio: $|x-2|/3<1\\Rightarrow R=3$.",
  },
  {
    prompt: "At an endpoint, a power series may:",
    options: ["Always converge", "Always diverge", "Converge or diverge — must test separately"],
    answer: "C",
    explanation: "Endpoint behavior is independent.",
  },
  {
    prompt: "If $\\sum|a_n|$ converges, then $\\sum a_n$:",
    options: ["May diverge", "Converges", "Oscillates"],
    answer: "B",
    explanation: "Absolute implies ordinary convergence.",
  },
  {
    prompt: "Using the Alternating Series Estimation Theorem on $\\sum_{n=1}^\\infty \\dfrac{(-1)^{n+1}}{n^2}$, the error in approximating the sum by $S_4$ is at most:",
    options: ["$1/16$", "$1/25$", "$1/36$"],
    answer: "B",
    explanation: "Error $|S - S_4| \\le b_5 = \\frac{1}{5^2} = \\frac{1}{25}$.",
  },
  {
    prompt: "Find the radius of convergence $R$ of the power series $\\sum_{n=1}^\\infty \\dfrac{(3x)^n}{n}$:",
    options: ["$R = 1/3$", "$R = 3$", "$R = 1$"],
    answer: "A",
    explanation: "Ratio test: $\\lim |\\frac{(3x)^{n+1}}{n+1} \\frac{n}{(3x)^n}| = 3|x| < 1 \\implies |x| < 1/3$.",
  },
  {
    prompt: "The series $\\sum_{n=1}^\\infty \\dfrac{(-1)^{n+1}}{\\sqrt{n}}$ is:",
    options: ["Absolutely convergent", "Conditionally convergent", "Divergent"],
    answer: "B",
    explanation: "Converges by AST because $1/\\sqrt{n}$ decreases to $0$. However, $\\sum 1/\\sqrt{n}$ is a $p$-series with $p=1/2 \\le 1$, which diverges.",
  },
  {
    prompt: "Applying the Root Test to $\\sum_{n=1}^\\infty \\left(\\dfrac{2n+1}{3n-1}\\right)^n$ gives $L$ equal to:",
    options: ["$2/3$ (converges)", "$1$ (inconclusive)", "$3/2$ (diverges)"],
    answer: "A",
    explanation: "$L = \\lim \\sqrt[n]{|a_n|} = \\lim \\frac{2n+1}{3n-1} = \\frac{2}{3} < 1$, so the series converges.",
  },
  {
    prompt: "The interval of convergence for $\\sum_{n=1}^\\infty \\dfrac{(x-2)^n}{n}$ is:",
    options: ["$(1, 3)$", "$[1, 3)$", "$[1, 3]$"],
    answer: "B",
    explanation: "Radius $R = 1$, centered at $2$, so test endpoints $x=1$ and $x=3$. At $x=1$, $\\sum (-1)^n/n$ converges (alternating harmonic). At $x=3$, $\\sum 1/n$ diverges (harmonic). Hence $[1, 3)$.",
  },
];

export const CONICS_P1_QUIZ = [
  {
    prompt: "Distance between $(1,2)$ and $(4,6)$ is:",
    options: ["$5$", "$\\sqrt{7}$", "$7$"],
    answer: "A",
    explanation: "$\\sqrt{3^2+4^2}=5$.",
  },
  {
    prompt: "Circle $(x-1)^2+(y+2)^2=9$ has radius:",
    options: ["$1$", "$3$", "$9$"],
    answer: "B",
    explanation: "$r=\\sqrt{9}=3$.",
  },
  {
    prompt: "Midpoint of $(0,0)$ and $(4,6)$ is:",
    options: ["$(4,6)$", "$(1,2)$", "$(2,3)$"],
    answer: "C",
    explanation: "Average coordinates.",
  },
  {
    prompt: "Parabola $y^2=8x$ has focus:",
    options: ["$(0,2)$", "$(2,0)$", "$(8,0)$"],
    answer: "B",
    explanation: "$4a=8\\Rightarrow a=2$; focus $(a,0)$.",
  },
  {
    prompt: "Ellipse $x^2/25+y^2/9=1$ has vertices at:",
    options: ["$(\\pm 5,0)$", "$(0,\\pm 5)$", "$(\\pm 3,0)$"],
    answer: "A",
    explanation: "$a=5$ along $x$.",
  },
  {
    prompt: "Eccentricity of a circle is:",
    options: ["$1/2$", "$1$", "$0$"],
    answer: "C",
    explanation: "$e=0$ for circles.",
  },
  {
    prompt: "Complete the square: $x^2+y^2-4x+6y=0$ is circle center:",
    options: ["$(-2,3)$", "$(4,-6)$", "$(2,-3)$"],
    answer: "C",
    explanation: "$(x-2)^2+(y+3)^2=13$.",
  },
  {
    prompt: "Directrix of $y^2=4ax$ is:",
    options: ["$y=-a$", "$x=-a$", "$x=a$"],
    answer: "B",
    explanation: "Standard.",
  },
  {
    prompt: "For ellipse $x^2/a^2+y^2/b^2=1$ ($a>b$), $c=\\sqrt{a^2-b^2}$. Eccentricity is:",
    options: ["$c/a$", "$c/b$", "$a/c$"],
    answer: "A",
    explanation: "$e=c/a$.",
  },
  {
    prompt: "Hyperbola $x^2/9-y^2/16=1$ has asymptotes:",
    options: ["$y=\\pm\\dfrac{3}{4}x$", "$y=\\pm\\dfrac{4}{3}x$", "$y=\\pm x$"],
    answer: "B",
    explanation: "$y=\\pm(b/a)x$.",
  },
  {
    prompt: "Standard circle center $(h,k)$ radius $r$:",
    options: ["$y-k=r(x-h)$", "$x^2+y^2=r$", "$(x-h)^2+(y-k)^2=r^2$"],
    answer: "C",
    explanation: "Standard form.",
  },
  {
    prompt: "Parabola $x=y^2$ opens:",
    options: ["Right", "Up", "Left"],
    answer: "A",
    explanation: "$x=y^2$ opens along $+x$.",
  },
  {
    prompt: "Foci of $x^2/16+y^2/9=1$ are at:",
    options: ["$(\\pm\\sqrt{7},0)$", "$(0,\\pm\\sqrt{7})$", "$(\\pm 4,0)$"],
    answer: "A",
    explanation: "$c=\\sqrt{16-9}=\\sqrt{7}$.",
  },
  {
    prompt: "Radius of $x^2+y^2=49$ is:",
    options: ["$49$", "$14$", "$7$"],
    answer: "C",
    explanation: "$\\sqrt{49}=7$.",
  },
  {
    prompt: "Definition: parabola is locus of points equidistant from:",
    options: ["Center and vertex", "A focus and a directrix", "Two foci"],
    answer: "B",
    explanation: "Focus-directrix definition.",
  },
  {
    prompt: "The directrix of the parabola $y^2 = -12x$ is the vertical line:",
    options: ["$x = 3$", "$x = -3$", "$y = 3$"],
    answer: "A",
    explanation: "$4p = 12 \\implies p = 3$. Opening left, the focus is $(-3, 0)$ and the directrix is $x = p = 3$.",
  },
  {
    prompt: "For the ellipse $\\dfrac{x^2}{25} + \\dfrac{y^2}{9} = 1$, the distance from center to each directrix is:",
    options: ["$25/4$", "$4$", "$5/4$"],
    answer: "A",
    explanation: "$a = 5, b = 3 \\implies c = \\sqrt{25 - 9} = 4$. Eccentricity $e = c/a = 4/5$. Directrix distance $d = a/e = 5 / (4/5) = 25/4$.",
  },
  {
    prompt: "The asymptotes of the hyperbola $\\dfrac{x^2}{16} - \\dfrac{y^2}{9} = 1$ are given by:",
    options: ["$y = \\pm \\dfrac{3}{4}x$", "$y = \\pm \\dfrac{4}{3}x$", "$y = \\pm \\dfrac{9}{16}x$"],
    answer: "A",
    explanation: "Standard horizontal hyperbola asymptotes are $y = \\pm (b/a)x = \\pm (3/4)x$.",
  },
  {
    prompt: "The focal length of the ellipse $9x^2 + 25y^2 = 225$ (distance between the two foci $2c$) is:",
    options: ["$4$", "$8$", "$10$"],
    answer: "B",
    explanation: "Standard form $\\frac{x^2}{25} + \\frac{y^2}{9} = 1 \\implies a^2=25, b^2=9 \\implies c = \\sqrt{25-9} = 4$. Distance between foci is $2c = 8$.",
  },
  {
    prompt: "The eccentricity of a rectangular (equilateral) hyperbola $x^2 - y^2 = a^2$ is always:",
    options: ["$\\sqrt{2}$", "$2$", "$1$"],
    answer: "A",
    explanation: "$b = a \\implies c = \\sqrt{a^2 + b^2} = \\sqrt{2a^2} = a\\sqrt{2}$. Therefore $e = c/a = \\sqrt{2}$.",
  },
];

export const CONICS_P2_QUIZ = [
  {
    prompt: "Discriminant $B^2-4AC<0$ (nondegenerate) indicates:",
    options: ["Ellipse type", "Parabola", "Hyperbola"],
    answer: "A",
    explanation: "Classification invariant.",
  },
  {
    prompt: "$B^2-4AC=0$ indicates:",
    options: ["Ellipse", "Hyperbola", "Parabola type"],
    answer: "C",
    explanation: "Classification.",
  },
  {
    prompt: "$B^2-4AC>0$ indicates:",
    options: ["Circle", "Hyperbola type", "Ellipse"],
    answer: "B",
    explanation: "Classification.",
  },
  {
    prompt: "Polar conic $r=\\dfrac{ed}{1-e\\cos\\theta}$ with $e=1$ is a:",
    options: ["Ellipse", "Hyperbola", "Parabola"],
    answer: "C",
    explanation: "$e=1$ parabola.",
  },
  {
    prompt: "If $e>1$ in that polar form, the curve is a:",
    options: ["Circle", "Hyperbola", "Ellipse"],
    answer: "B",
    explanation: "$e>1$ hyperbola.",
  },
  {
    prompt: "Rotation of axes is used when the $xy$ term:",
    options: ["Is present ($B\\ne 0$)", "Equals $A$", "Is zero"],
    answer: "A",
    explanation: "Eliminate $Bxy$ by rotation.",
  },
  {
    prompt: "Parametric circle $x=3\\cos t$, $y=3\\sin t$ has radius:",
    options: ["$1$", "$3$", "$9$"],
    answer: "B",
    explanation: "Amplitude $3$.",
  },
  {
    prompt: "Reflective property of a parabola: rays parallel to the axis reflect toward:",
    options: ["The focus", "The directrix", "The vertex only"],
    answer: "A",
    explanation: "Optical property.",
  },
  {
    prompt: "Translate $X=x-2$, $Y=y+1$. Point $(x,y)=(2,-1)$ maps to:",
    options: ["$(2,-1)$", "$(4,0)$", "$(0,0)$"],
    answer: "C",
    explanation: "Origin of translated system.",
  },
  {
    prompt: "For $e=0$ polar conic you get a:",
    options: ["Hyperbola", "Circle", "Parabola"],
    answer: "B",
    explanation: "$e=0$ circle.",
  },
  {
    prompt: "General second-degree $Ax^2+Bxy+Cy^2+Dx+Ey+F=0$ represents a conic when:",
    options: ["$D=E=0$", "$F=0$", "Not all of $A,B,C$ are zero"],
    answer: "C",
    explanation: "Quadratic part nontrivial.",
  },
  {
    prompt: "Ellipse eccentricity satisfies:",
    options: ["$0\\le e<1$", "$e=1$", "$e>1$"],
    answer: "A",
    explanation: "Range for ellipses.",
  },
  {
    prompt: "Parametric $x=a\\cosh t$, $y=b\\sinh t$ traces a:",
    options: ["Hyperbola branch", "Ellipse", "Parabola"],
    answer: "A",
    explanation: "Hyperbolic identity.",
  },
  {
    prompt: "After translating to remove linear terms, an ellipse equation looks like:",
    options: ["$Y=X^2$", "$XY=1$", "$X^2/a^2+Y^2/b^2=1$"],
    answer: "C",
    explanation: "Standard translated form.",
  },
  {
    prompt: "Satellite dish design uses which reflective property?",
    options: ["Ellipse two-foci property only", "Parabola focus property", "Hyperbola asymptotes"],
    answer: "B",
    explanation: "Parallel rays to focus.",
  },
  {
    prompt: "To remove the $xy$-term from $x^2 + 2\\sqrt{3}xy + 3y^2 - 4x = 0$, the acute rotation angle $\\theta$ is:",
    options: ["$\\theta = 30^\\circ$", "$\\theta = 45^\\circ$", "$\\theta = 60^\\circ$"],
    answer: "A",
    explanation: "$\\cot(2\\theta) = \\frac{A-C}{B} = \\frac{1-3}{2\\sqrt{3}} = -\\frac{1}{\\sqrt{3}} \\implies 2\\theta = 120^\\circ \\text{ (or acute principal angle } -60^\\circ), \\text{ so } \\theta = 30^\\circ$ or $60^\\circ$ aligns with the principal axes.",
  },
  {
    prompt: "The polar equation $r = \\dfrac{6}{2 - 2\\cos\\theta} = \\dfrac{3}{1 - \\cos\\theta}$ represents:",
    options: ["A parabola ($e = 1$)", "An ellipse ($e = 1/2$)", "A hyperbola ($e = 2$)"],
    answer: "A",
    explanation: "Matches standard polar conic form $r = \\frac{ed}{1 - e\\cos\\theta}$ with eccentricity $e = 1$, which is a parabola.",
  },
  {
    prompt: "In the general quadratic $4x^2 - 4xy + y^2 - 8x - 6y + 5 = 0$, the discriminant $B^2 - 4AC$ equals:",
    options: ["$0$ (parabola)", "$-16$ (ellipse)", "$32$ (hyperbola)"],
    answer: "A",
    explanation: "$B = -4, A = 4, C = 1 \\implies B^2 - 4AC = (-4)^2 - 4(4)(1) = 16 - 16 = 0$.",
  },
  {
    prompt: "A satellite reflector reflects parallel rays from an incoming distant source directly to:",
    options: ["The directrix", "The vertex", "The focus"],
    answer: "C",
    explanation: "The reflective property of a parabolic mirror directs all incoming parallel rays to its geometric focus.",
  },
  {
    prompt: "For a hyperbolic celestial orbit around the Sun with perihelion distance $r_p = 2\\text{ AU}$ and eccentricity $e = 1.5$, the semi-major axis $a$ equals:",
    options: ["$4\\text{ AU}$", "$3\\text{ AU}$", "$2\\text{ AU}$"],
    answer: "A",
    explanation: "Perihelion distance for a hyperbola is $r_p = a(e - 1)$. Thus $2 = a(1.5 - 1) = 0.5a \\implies a = 4\\text{ AU}$.",
  },
];
